export default class Address {
    constructor() {
        this._Street = null;
        this._City = null;
        this._Zip = null;
        this._State = null;
    }

    toDTO() {
        return {
            Street: this.Street,
            City: this.City,
            State: this.State,
            Zip: this.Zip
        }
    }

    get Street() {
        return this._Street;
    }

    set Street(value) {
        this._Street = value;
    }

    get City() {
        return this._City;
    }

    set City(value) {
        this._City = value;
    }

    get Zip() {
        return this._Zip;
    }

    set Zip(value) {
        this._Zip = value;
    }

    get State() {
        return this._State;
    }

    set State(value) {
        this._State = value;
    }
}